/**
 * 日充值报表路由
 */
const RechargeRouter = {
  path: 'rechargeDay',
  name: 'RechargeDay',
  meta: {
    requiresAuth: false,
    leftMenu: true // false表示不需要左边菜单栏
  },
  component: () => import('@/views/RechargeDay/index')
}
export default RechargeRouter
